import React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/system';


const StyledDefaultAuthor = styled('span')({
    fontWeight: 'normal'
});

const StyledAuthorOwner = styled('span')({
    fontWeight: 'bold'
});


class AuthorList extends React.Component {
    constructor(props) {
        super(props);
    }

    get_styled_author = (author) => {
        let StyledAuthor = author.owner ? StyledAuthorOwner : StyledDefaultAuthor;
        return (
            <StyledAuthor>{author.name}{author.owner && '*'}</StyledAuthor>
        )
    };

    render() {
        return (
            <span>
                {this.props.authors.map((author, index) =>
                    <span key={index}>
                        {this.get_styled_author(author, index)}
                        <span>{index < this.props.authors.length-1 ? ', ' : ''}</span>
                    </span>
                )}
            </span>
        );
    }

}

AuthorList.propTypes = {
    authors: PropTypes.array
};

export default AuthorList;
